import DashboardLayout from "../layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "../pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "../pages/Dashboard.vue";
import UserProfile from "../pages/UserProfile.vue";
import UserRightsManagement from "../pages/UserRightsManagement";
import MarksHistory from "../pages/MarksHistory";
import AppointmentCompetention from "../pages/AppointmentCompetention";
import Interviews from "../pages/Interviews";
import Detail from "../pages/Detail";
import InterviewDetail from "../pages/InterviewDetail";
import Notifications from "../pages/Notifications.vue";
import Icons from "../pages/Icons.vue";
import Maps from "../pages/Maps.vue";
import Typography from "../pages/Typography.vue";
import TableList from "../pages/TableList.vue";
import TestPage from "../pages/TestPage";
import CategoryLayout from "../layout/categories/CategoryLayout";
import AuthenticationPage from "../pages/AuthenticationPage";
import Categories from "../components/Catergories/Categories";
import RolePage from "@/pages/RolePage.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/profile",
    meta: { requiresAuth: true },
    children: [
      {
        path: "/profile",
        name: "profile",
        component: UserProfile,
        meta: {
          title: "Личный кабинет",
        }
      },
      {
        path: "/role-create",
        name: "role-creation",
        meta: {
          title: "Создание роли",
        },
        component: RolePage,
      },
      
      {
        path: "/areasLayout",
        name: "areasLayout",
        meta: {
          title: "Области знаний",
          type: "area",
          key: "aName",
          level: 1
        },
        component: CategoryLayout,
      },
      {
        path: "/area/:id",
        name: "area",
        meta: {
          title: "Компетенции",
          type: "competency",
          key: "cName",
          level: 2
        },
        component: CategoryLayout,
      },
      {
        path: "/competency/:id",
        name: "competency",
        meta: {
          title: "Темы",
          type: "theme",
          key: "tName",
          level: 3
        },
        component: CategoryLayout,
      },
      {
        path: "/theme/:id",
        name: "theme",
        meta: {
          title: "Подтемы",
          type: "subtopic",
          key: "sName",
          level: 4
        },
        component: CategoryLayout,
      },

      {
        path: "/subtopic/:id",
        name: "subtopic",
        meta: {
          title: "Вопросы и задания",
          type: "question",
          key: "qName",
          level: 5
        },
        component: CategoryLayout,
      },
  
      {
        path: "user-rights",
        name: "user-rights",
        meta: {
          title: "Пользователи",
        },
        component: UserRightsManagement,
      },
      {
        path: "/history",
        name: "history",
        meta: {
          title: "История оценнок",
        },
        component: MarksHistory,
      },
      {
        path: "/appointment",
        name: "appointment",
        meta: {
          title: "Назначение компетенций",
        },
        component: AppointmentCompetention,
      },
      {
        path: "/interviews",
        name: "interviews",
        meta: {
          title: "Интервью",
        },
        component: Interviews,
      },
      {
        path: "/Detail",
        name: "Detail",
        meta: {
          title: "Интервью детальная",
        },
        component: Detail,
      },
      {
        path: "/InterviewDetail",
        name: "InterviewDetail",
        meta: {
          title: "Страница интервью",
        },
        component: InterviewDetail,
      },
      {
        path: "notifications",
        name: "notifications",
        meta: {
          title: "Уведомления",
        },
        component: Notifications,
      },
      {
        path: "icons",
        name: "icons",
        meta: {
          title: "icons",
        },
        component: Icons,
      },
      {
        path: "maps",
        name: "maps",
        meta: {
          title: "maps",
        },
        component: Maps,
      },
      {
        path: "typography",
        name: "typography",
        meta: {
          title: "typography",
        },
        component: Typography,
      },
      {
        path: "table-list",
        name: "table-list",
        meta: {
          title: "table-list",
        },
        component: TableList,
      },
    ],
  },
  {
    path: "/authentication",
    name: "authentication",
    meta: {
      title: "Авторизация",
    },
    component: AuthenticationPage,
  },
  { path: "*", component: NotFound },
];


/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
